import {BaseModel} from "../base-model";

export interface ICommonObjectModel {
	Id: number;
	Reference: string;
}
export class CommonObjectModel extends BaseModel<ICommonObjectModel>{
    Id: number;
    Reference: string;
	
	constructor(props?: ICommonObjectModel) {
	    super(props);
    }
	
}